import { ApiService } from './api.service';
import { SchoolGroupTrendAnalysis } from '@/models/school-group/school-group-trend-analysis';

class SchoolGroupTrendAnalysisService extends ApiService {
  constructor() {
    super();
  }

  getSchoolGroupTrendAnalysis(targetType: number = 0, targetID: number = 0, tagIDs: string = ''): Promise<SchoolGroupTrendAnalysis> {
    return this.get(SchoolGroupTrendAnalysis, 'schoolGroups/trendAnalysis', {
      targetType,
      targetID,
      tagIDs,
    });
  }

  getSchoolGroupTrendAnalysisForStatistics(targetType: number = 0, targetID: number = 0, tagIDs: string = '', evalSettingID: number = 0): Promise<SchoolGroupTrendAnalysis> {
    return this.get(SchoolGroupTrendAnalysis, 'statistics/trendAnalysis', {
      targetType,
      targetID,
      tagIDs,
      evalSettingID,
    });
  }
}

export const schoolGroupTrendAnalysisService = new SchoolGroupTrendAnalysisService();
